import { themeStore } from "@/stores";

export const useTheme = () => themeStore;
